"use client"

import { XMarkIcon } from "@heroicons/react/20/solid"
import { clsx } from "clsx"
import { FC, ReactNode, useCallback, useEffect, useState } from "react"

interface Props {
    dismissible?: boolean
    name: string
    children: ReactNode
    className?: string
}

export const useDismissMemory = ({ key }: { key: string }) => {
    const [isDismissed, setIsDismissed] = useState<boolean>(false)

    useEffect(() => {
        const isDismissed = localStorage.getItem(key) === "true"
        setIsDismissed(isDismissed)
    }, [key])

    const dismiss = useCallback(() => {
        localStorage.setItem(key, "true")
        setIsDismissed(true)
    }, [key])

    return { dismiss, isDismissed }
}

export const TopBanner: FC<Props> = ({ children, className, dismissible = true, name }) => {
    const { dismiss, isDismissed } = useDismissMemory({ key: name })

    const visible = !dismissible || !isDismissed

    return visible ? (
        <div className={clsx("flex items-center gap-x-6 px-6 py-2.5 sm:px-3.5 sm:before:flex-1", className)}>
            <p className="text-sm leading-6 text-white">{children}</p>
            <div className="flex flex-1 justify-end">
                {dismissible ? (
                    <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]" onClick={dismiss}>
                        <span className="sr-only">Dismiss</span>
                        <XMarkIcon className="h-5 w-5 text-white" aria-hidden="true" />
                    </button>
                ) : (
                    <></>
                )}
            </div>
        </div>
    ) : (
        <></>
    )
}
